<template>
  <div
    class="relative flex h-96 items-center justify-center rounded-lg border border-gray-300 bg-gray-200 bg-center bg-no-repeat"
    style="
      background-image: url(&quot;https://jiffy.imgix.net/gen/neck-label-start-design-zone.png?ixlib=rb-0.3.5&w=550&dpr=2&quot;);
      background-size: cover;
    "
  >
    <!-- Neck Label Builder -->
    <div class="neck-label-builder mx-auto max-w-sm rounded-lg bg-blue-50/80 p-2">
      <div class="rounded-lg border-2 border-dashed border-blue-300 p-4">
        <!-- Header Button -->
        <div class="mb-2">
          <a
            class="inline-block w-full cursor-pointer rounded-lg !bg-[#2563eb] px-4 py-3 text-center text-white !no-underline transition-colors duration-200 ease-in-out hover:!bg-[#1d4ed8] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
            href="/design-tag"
            data-testid="build-your-neck-label-button"
            @click="trackNeckLabelStartDesign"
          >
            <span class="text-base font-semibold text-white">Build Your Neck Label</span>
          </a>
        </div>

        <!-- Size Display -->
        <div class="mb-2 flex items-center justify-center">
          <div class="h-px flex-1 bg-blue-400"></div>
          <div class="px-4 text-base font-bold text-gray-900">2XL</div>
          <div class="h-px flex-1 bg-blue-400"></div>
        </div>

        <!-- Material Composition -->
        <div class="mb-2 space-y-1 text-center text-gray-800">
          <div class="m-0 text-xs font-semibold">70% COTTON</div>
          <div class="m-0 text-xs font-semibold">30% POLYESTER</div>
        </div>
        <span class="my-3 flex h-px bg-blue-400"></span>

        <!-- Care Instructions Icons -->
        <div class="flex items-center justify-center space-x-3">
          <div class="h-8 w-8">
            <UseSvg icon="do-not-iron" type="neck_labels" class="h-full w-full text-gray-700" />
          </div>
          <div class="h-8 w-8">
            <UseSvg icon="do-not-wash" type="neck_labels" class="h-full w-full text-gray-700" />
          </div>
          <div class="h-8 w-8">
            <UseSvg icon="chlorine-bleach" type="neck_labels" class="h-full w-full text-gray-700" />
          </div>
          <div class="h-8 w-8">
            <UseSvg icon="do-not-bleach" type="neck_labels" class="h-full w-full text-gray-700" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UseSvg from "components/jiffy/vue-cart/UseSvg.vue";
import { trackStartDesign } from "../design-tag/utils/trackNeckLabelEvent";

export default {
  name: "DesignTagCreationPanel",
  components: { UseSvg },
  methods: {
    trackNeckLabelStartDesign() {
      trackStartDesign({ location: "pdp" });
    }
  }
};
</script>
